module.exports = __webpack_public_path__ + "img/medicos-especialistas.51a0cb63.jpg";